import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: 'home',
  },
  {
    path: '/404',
    component: () => import('@/views/404.vue'),
  },
  // { path: '*', redirect: '/404' },
  {
    path: '/home',
    name: 'home',
    component: (resolve) => require(['@/views/Home.vue'], resolve),
    meta: {
      title: 'Home',
    },
  },
  // 创新服务
  {
    redirect: 'Innovate/jiceng',
    path: '/Innovate',
    name: 'Innovate',
    component: (resolve) => require(['@/views/Innovate/Innovate.vue'], resolve),
    meta: {
      title: '创新服务',
    },
    children: [
      {
        path: 'jiceng',
        name: 'jiceng',
        component: (resolve) =>
          require(['@/views/Innovate/jiceng.vue'], resolve),
        meta: {
          title: 'Work with primary-level governments',
        },
      },
      {
        path: 'touxi',
        name: 'touxi',
        component: (resolve) =>
          require(['@/views/Innovate/touxi.vue'], resolve),
        meta: {
          title: 'Setting up of Hemodialysis Unit',
        },
      },
      {
        path: 'doctorIP',
        name: 'doctorIP',
        component: (resolve) =>
          require(['@/views/Innovate/doctorIP.vue'], resolve),
        meta: {
          title: 'self-media brands operation',
        },
      },
      {
        path: 'kexue',
        name: 'kexue',
        component: (resolve) =>
          require(['@/views/Innovate/kexue.vue'], resolve),
        meta: {
          title: 'Advertisement of hospital departments',
        },
      },
      {
        path: 'shuzi',
        name: 'shuzi',
        component: (resolve) =>
          require(['@/views/Innovate/shuzi.vue'], resolve),
        meta: {
          title: 'Digital Marketing',
        },
      },
      {
        path: 'yidi',
        name: 'yidi',
        component: (resolve) => require(['@/views/Innovate/yidi.vue'], resolve),
        meta: {
          title: 'strange land Hemodialysis',
        },
      },
    ],
  },
  //  工业生产
  {
    path: '/Industry',
    name: 'Industry',
    component: (resolve) => require(['@/views/Industry/Industry.vue'], resolve),
    meta: {
      title: '工业生产',
    },
    redirect: 'Industry/kaineng',
    children: [
      {
        path: 'kaineng',
        name: 'kaineng',
        component: (resolve) =>
          require(['@/views/Industry/kaineng.vue'], resolve),
        meta: {
          title: 'Kangdewei',
        },
      },
      {
        path: 'water',
        name: 'water',
        component: (resolve) =>
          require(['@/views/Industry/water.vue'], resolve),
        meta: {
          title: 'Hemodialysis Water Treatment Equipment',
        },
      },
      {
        path: 'jizhong',
        name: 'jizhong',
        component: (resolve) =>
          require(['@/views/Industry/jizhong.vue'], resolve),
        meta: {
          title: 'Dialysis Centralized Liquid Supply System',
        },
      },
    ],
  },
  {
    path: '/Business',
    name: 'Business',
    component: (resolve) => require(['@/views/Business.vue'], resolve),
    meta: {
      title: '商业渠道',
    },
  },
  {
    path: '/Science',
    name: 'Science',
    component: (resolve) => require(['@/views/Science/Science.vue'], resolve),
    meta: {
      title: '医学培训',
    },
    redirect: 'Science/zhuanxiang',
    children: [
      {
        path: 'zhuanxiang',
        name: 'zhuanxiang',
        component: (resolve) =>
          require(['@/views/Science/zhuanxiang.vue'], resolve),
        meta: {
          title: 'Special Training',
        },
      },
      {
        path: 'jiaoxue',
        name: 'jiaoxue',
        component: (resolve) =>
          require(['@/views/Science/jiaoxue.vue'], resolve),
        meta: {
          title: 'Live Teaching',
        },
      },
      {
        path: 'xueshu',
        name: 'xueshu',
        component: (resolve) =>
          require(['@/views/Science/xueshu.vue'], resolve),
        meta: {
          title: 'Academic Promotion',
        },
      },
      {
        path: 'jineng',
        name: 'jineng',
        component: (resolve) =>
          require(['@/views/Science/jineng.vue'], resolve),
        meta: {
          title: 'Competition',
        },
      },
      {
        path: 'bingli',
        name: 'bingli',
        component: (resolve) =>
          require(['@/views/Science/bingli.vue'], resolve),
        meta: {
          title: 'Cases Collection',
        },
      },
    ],
  },
  {
    path: '/Trends',
    name: 'Trends',
    component: (resolve) => require(['@/views/Trends.vue'], resolve),
    meta: {
      title: '公司动态',
    },
  },
  // 信息平台
  {
    path: '/News',
    name: 'News',
    component: (resolve) => require(['@/views/News/News.vue'], resolve),
    meta: {
      title: '信息平台',
    },
    redirect: 'News/keshigl',
    children: [
      {
        path: 'keshigl',
        name: 'keshigl',
        component: (resolve) => require(['@/views/News/keshi.vue'], resolve),
        meta: {
          title: 'Department Management System',
        },
      },
      {
        path: 'watergl',
        name: 'watergl',
        component: (resolve) => require(['@/views/News/water.vue'], resolve),
        meta: {
          title: 'Dialysis Water Treatment System',
        },
      },
      {
        path: 'huanzhegl',
        name: 'huanzhegl',
        component: (resolve) => require(['@/views/News/huanzhe.vue'], resolve),
        meta: {
          title: 'Patient Management System',
        },
      },
    ],
  },
  // 关于我们
  {
    path: '/About',
    name: 'About',
    component: (resolve) => require(['@/views/About/about.vue'], resolve),
    meta: {
      title: '关于我们',
    },
    redirect: 'About/fazhan',
    children: [
      {
        path: 'fazhan',
        name: 'fazhan',
        component: (resolve) => require(['@/views/About/fazhan.vue'], resolve),
        meta: {
          title: 'The GYT Timeline',
        },
      },
      {
        path: 'rencai',
        name: 'rencai',
        component: (resolve) => require(['@/views/About/rencai.vue'], resolve),
        meta: {
          title: 'Talent recruitment',
        },
      },
    ],
  },
]

const router = new VueRouter({
  routes,
})
// router.afterEach((to) => {
//   console.log(to)
//   // window.scrollTo(0, 0)
// })
export default router
